import { forwardRef, lazy, Suspense } from 'react';
// @mui
import { Box, BoxProps } from '@mui/material';
//
import { IconifyProps } from './types';
import { ICON_MAP } from './iconMap';

// ----------------------------------------------------------------------

interface Props extends Omit<BoxProps, 'component' | 'width'> {
  icon: IconifyProps;
  width?: number;
}

const Iconify = forwardRef<HTMLSpanElement, Props>(({ icon, width = 20, sx, ...other }, ref) => {
  const iconStr = typeof icon === 'string' ? icon : '';
  const IconComp = iconStr ? ICON_MAP[iconStr] : null;
  const size = typeof width === 'number' ? width : 20;

  if (IconComp) {
    return (
      <Box
        ref={ref}
        component="span"
        sx={{ width: size, height: size, display: 'inline-flex', lineHeight: 1, flexShrink: 0, ...sx }}
        {...other}
      >
        <IconComp width={size} height={size} />
      </Box>
    );
  }
  console.log(iconStr)
  return (
    <Box ref={ref} component="span" sx={{ display: 'inline-flex', lineHeight: 1, flexShrink: 0 }}>
      <Suspense fallback={<Box component="span" sx={{ width: size, height: size, display: 'inline-block', ...sx }} />}>
        <IconEvaDropletOffOutline width={size} height={size} />
      </Suspense>
    </Box>
  );
});

Iconify.displayName = 'Iconify';

export default Iconify;
